module.exports = __webpack_public_path__ + "static/media/HeaderFSLS.c0ec3c43.png";